import React, { useRef, useEffect } from 'react';

import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import { useField } from '@unform/core';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { canURL } from '~/helpers';

function Input({ name, label, getValue, serialize, disabled, ...rest }) {
  const inputRef = useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);

  function handleChangeValue(event) {
    const { value } = event.target;
    inputRef.current.value = serialize(value);

    getValue(serialize(value));
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  useEffect(() => {
    inputRef.current.value = defaultValue;
    if (defaultValue) getValue(serialize(defaultValue));
  }, [defaultValue]);

  useEffect(() => {
    if (disabled) clearError();
  }, [disabled]);

  return (
    <FormControl style={{ width: '100%' }}>
      <TextField
        ref={inputRef}
        onChange={handleChangeValue}
        error={!!error}
        defaultValue={defaultValue}
        label={label}
        variant="outlined"
        fullWidth
        id={name}
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        {...rest}
        disabled={permission || disabled}
        onFocus={clearError}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  getValue: PropTypes.func,
  serialize: PropTypes.func,
  disabled: PropTypes.bool,
};

Input.defaultProps = {
  getValue: () => {},
  serialize: (value) => value,
  disabled: false,
};

export default Input;
